<template>
  <app-client-layout title="ユーザ情報確認">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        ユーザ情報確認
      </h2>
    </template>
    <div class="mx-auto max-w-5xl bg-white m-4 p-8 sm:px-6 lg:px-8">
      <div class="sm:grid sm:grid-cols-3">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">ユーザID</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.id }}</p>
        </div>
      </div>
      <div class="sm:grid sm:grid-cols-3 mt-10">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">メールアドレス</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.email }}</p>
        </div>
      </div>
      <div class="sm:grid sm:grid-cols-3 mt-10">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">看護師学校との連携</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.linked_school_id ? "連携済み" : "未連携" }}</p>
        </div>
      </div>
      <div class="mt-10 border-t border-gray-100"></div>
      <div class="sm:grid sm:grid-cols-3 mt-6">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">名前</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.name ?? "-" }}</p>
        </div>
      </div>
      <div class="sm:grid sm:grid-cols-3 mt-6">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">性別</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ sex }}</p>
        </div>
      </div>
      <div class="sm:grid sm:grid-cols-3 mt-6">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">郵便番号</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.postal_code ?? "-" }}</p>
        </div>
      </div>
      <div class="sm:grid sm:grid-cols-3 mt-6">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">住所</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.address ?? "-" }}</p>
        </div>
      </div>
      <div class="sm:grid sm:grid-cols-3 mt-6">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">職業</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.job }}</p>
        </div>
      </div>
      <div class="sm:grid sm:grid-cols-3 mt-6">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">勤続年数</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.service_years }}</p>
        </div>
      </div>
      <div class="sm:grid sm:grid-cols-3 mt-6">
        <div class="col-span-1">
          <h2 class="text-lg sm:text-right">所属先</h2>
        </div>
        <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
          <p>{{ user.affiliation ?? "-" }}</p>
        </div>
      </div>
      <template v-if="user.linked_school_id">
        <div class="sm:grid sm:grid-cols-3 mt-6">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">学校名</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
            <p>{{ user.school ?? "-" }}</p>
          </div>
        </div>
        <div class="sm:grid sm:grid-cols-3 mt-6">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">学科・学部</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
            <p>{{ user.department ?? "-" }}</p>
          </div>
        </div>
        <div class="sm:grid sm:grid-cols-3 mt-6">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">学校Email</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
            <p>{{ user.school_email ?? "-" }}</p>
          </div>
        </div>
        <div class="sm:grid sm:grid-cols-3 mt-6">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">入学年月</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
            <p>{{ user.date_of_admission ?? "-" }}</p>
          </div>
        </div>
        <div class="sm:grid sm:grid-cols-3 mt-6">
          <div class="col-span-1">
            <h2 class="text-lg sm:text-right">学籍番号</h2>
          </div>
          <div class="col-span-2 mt-4 sm:mt-0 ml-4 sm:ml-16 text-gray-500">
            <p>{{ user.student_id ?? "-" }}</p>
          </div>
        </div>
      </template>
    </div>
  </app-client-layout>
</template>

<script setup>
import { computed } from 'vue'
import AppClientLayout from '@/Layouts/AppClientLayout'

const props = defineProps({
  user: {
    type: Object,
    require: true,
  },
})

const sex = computed(() => {
  switch (props.user.sex) {
    case 0:
      return '男性'
    case 1:
      return '女性'
    case 2:
      return '無回答'
    default:
      return '-'
  }
})
</script>
